import React from "react";
import { connect } from "react-redux";
import qs from "qs";
import T from "i18n-react";
import { formAuth } from "../actions/CompanyPublicationShareActions";
import { replace } from "connected-react-router";
import Notifications from "react-notification-system-redux";

const mapDispatchToProps = (dispatch, props) => ({
	dispatch,
	formAuth: (params, data) =>
		dispatch(formAuth(props.match.params.shareId, params, data))
});

const mapStateToProps = ({ Share: { auth } }) => ({
	auth
});

export class DokivShareFormAuth extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			password: ""
		};

		this.submitPassword = this.submitPassword.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.auth !== nextProps.auth && nextProps.auth) {
			const query = qs.parse(nextProps.location.search, {
				ignoreQueryPrefix: true
			});
			query.auth = nextProps.auth;

			const queryStr = qs.stringify(query, {
				encode: true,
				addQueryPrefix: true
			});
			this.props.dispatch(
				replace(`/forms/${this.props.match.params.shareId}${queryStr}`)
			);
		}
	}

	submitPassword(e) {
		e.preventDefault();
		const query = qs.parse(this.props.location.search, {
			ignoreQueryPrefix: true
		});

		this.props.formAuth(query, { password: this.state.password }).then(
			() => { },
			() => {
				this.props.dispatch(
					Notifications.error({
						title: "",
						message: "Invalid password",
						position: "tc",
						autoDismiss: 5
					})
				);
			}
		);
	}

	render() {
		return (
			<div>
				<header className="share-header">
					<div className="share-header__bar main cf">
						<a
							href="https://dokiv.com/"
							className="share-header__logo"
						>
							<img alt="" src={process.env.PUBLIC_URL + "/images/logos/logo-horizontal-rbg-white.png"} />
						</a>
					</div>
				</header>

				<main className="content-holder">
					<div>
						<div className="share__auth-wrapper text-center skin">
							<form
								className="login__form"
								onSubmit={this.submitPassword}
							>
								<h3 className="row--large">
									{T.translate("enter-password")}
								</h3>
								<ul className="row--large">
									<li className="row--small">
										<input
											type="password"
											name="password"
											placeholder={T.translate(
												"password"
											)}
											onChange={e => {
												this.setState({
													password: e.target.value
												});
											}}
											value={this.state.password}
											required
										/>
									</li>

									<li className="row--small">
										<button
											type="submit"
											className="button button--system share__auth-btn"
										>
											{T.translate("form.submit")}
										</button>
									</li>
								</ul>
							</form>
						</div>
					</div>
				</main>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(DokivShareFormAuth);
